<template>
    <div>
      <!-- 头部 -->
      <top></top>
      <div class="main">
        <navMenu :active="active"></navMenu>
        <div class="content content-type" v-loading.fullscreen.lock="loading">
          <div class="main-title pd">已签订协议</div>
          <div  v-if="detail.deadline" class="main-sub pd">提交截止日期：{{ detail.deadline }}</div>
          <!-- <div class="main-title pd">{{ content.menu_title }}</div> -->
          <!-- <div class="main-sub pd" v-if="list[0].menu_mark == 'scheme'" v-html="content.title_brief"></div>
          <div class="main-sub pd" v-if="list[0].menu_mark == 'space'" v-html="content.title_brief_1"></div> -->
          <div  class="template-main pd content_box">
            <div class="content_html" v-html="content"></div>
          </div>

          <div class="conf-btn flex">
          <!-- 可跳过需要验证 -->
          <template  v-if="detail.is_skip==1&&detail.is_verify==1">
             <div class="btn" @click="next('skip')">跳过</div>
             <div class="btn next_btn" @click="next('next')">下一步</div>
          </template>
           <!-- 可跳过无需验证 -->
          <template  v-if="detail.is_skip==1&&detail.is_verify==0">
            <div class="btn next_btn" @click="next('known')">已知悉</div>
          </template>
          <!-- 不可跳过需要验证 -->
          <template  v-if="detail.is_skip==0&&detail.is_verify==1">
              <div class="btn next_btn" @click="next('next')">下一步</div>
          </template>
        </div>
      
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { getDetai, getConfig,skipOrReadStep,companyMenuDetail } from "@/api/api";
  import top from "../components/top.vue"; //头部
  import navMenu from "../components/navMenu.vue"; //左侧步骤条
  export default {
    components: { top, navMenu },
    name: "agreement",
    data() {
      return {
          id:'',
        loading: false,
        active: 1,
        userInfor: {},
        boothType: "",
        list: [],
        content: '',
        richHtml: "",
        stepJson: {},
        urlList: [],
        height: "",
        detail:{},

      };
    },
    mounted() {
        this.getData();
    },
    watch: {
     
    },
    methods: {
           // 跳转下一步
    next(type) {
      if(type=='next'){//下一步
        if(this.detail.action==1||this.detail.action==4){
          this.toPath();
        }else{
            this.$message.warning("请完善信息!")
        }

      }else if(type=='skip'){//跳过
        this.skipOrReadStep(1)
      }else if(type=='known'){//已知悉
        this.skipOrReadStep(2)
      }
    },
    // 跳过或者已知悉
    skipOrReadStep(action){

      let data={
        action,
        mark:this.detail.mark,
        type:JSON.parse(localStorage.getItem("userdata")).type
      }
      skipOrReadStep(data).then(res=>{
        if(res.code==1){
          this.$message.success("操作成功")
          this.toPath()
        }else{
          this.$message.error(res.msg)
        }

      }).catch(err=>{
        console.log(err)
      })

    },
      // 初始化数据
      getData() {
        let stepMenuList = JSON.parse(localStorage.getItem("menu"));
        this.stepMenuList = stepMenuList;
        let title = this.$route.query.title;
        
        var index = stepMenuList.findIndex(function (item) {
          return item.link_url == "/agreement"
        });
        this.detail=stepMenuList[index];
        console.log(stepMenuList[index],"detail=============")
        if(stepMenuList[index].children&&stepMenuList[index].children.length>0){
             this.list=stepMenuList[index].children
       }
        this.active = index;
        this.id = stepMenuList[index].id;
        console.log(stepMenuList[index],"stepMenuList[index]")
        // // 获取当前展位信息
        // let userdata = JSON.parse(localStorage.getItem("userdata"));
        // this.userInfor = userdata.datainfo;
        // if (this.userInfor.booth_sketch) {
        //   let arr = this.userInfor.booth_sketch;
        //   arr.forEach((item) => {
        //     this.urlList.push(item.thumb);
        //   });
        // }
        // this.boothType = userdata.datainfo.booth_type;
        // 获取页面标题 副标题 富文本
        this.getContent(this.id);
      },
       // 获取内容
      getContent(id) {
        this.loading = true;
          companyMenuDetail({ id }).then((res) => {
            console.log(res, "======res");
            if (res.code == 1) {
              let { data } = res;
              this.content = data.content;
                this.loading = false;
              console.log(this.content, '====this.content')
              // this.getStepStatus(data[0].menu_mark);
              // //获取二级展示信息及二级进度
              // this.getConfig(this.id);
              // if (data[0].step) {
              //   this.content.title_brief = data[0].step.title_brief;
              //   this.content.title_brief_1 = data[0].step.title_brief_1;
              //   this.richHtml = data[0].step.app_introduction;
              // } else {
              //   this.richHtml = "";
              // }
            }
          })
          .catch((err) => {
              this.loading = false;
            console.log(err);
          });
      },
      //获取二级进度配置
      getConfig(parent_menu_id) {
        getConfig({ parent_menu_id })
          .then((res) => {
            //console.log(res.data, "======获取二级进度配置");
            this.loading = false;
            if (res.code == 200) {
              let { data } = res;
              let newData = [];
              data.forEach((item) => {
                if (
                  (this.boothType == "1" && item.menu_mark != "space") ||
                  (this.boothType == "2" && item.menu_mark != "scheme")
                ) {
                  newData.push(item);
                }
              });
              this.list = newData;
              if (newData[0].menu_mark == "space") {
                setTimeout(() => {
                  this.height = this.$refs.infor.clientHeight;
                }, 10);
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
   
      // 跳转页面
      toList(path) {
        if (path.indexOf("http") >= 0) {
          window.open(path, "_blank");
        } else {
          this.$router.push({
            path,
          });
        }
      },
     
      toPath() {
     
        this.active = this.active + 1;
        let { link_url, menu_title, id } = this.stepMenuList[this.active];
        if (link_url == "/exhibitorManual" || link_url == "/standPrepare") {
          this.$router.push({
            path: link_url
          });
        } else {
          this.$router.push({
            path: link_url
          });
        }
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
    .content_box{
      display: flex;
      justify-content: center;
    }
    .content_html{
      width: 70%;
    }
  .conf-btn {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  .btn {
    min-width: 128px;
    height: 36px;
    cursor: pointer;
    margin: 0 10px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    line-height: 36px;
    text-align: center;
    background: #ffffff;
    border: 1px solid #CAD2DD;
    border-radius: 9px;
    &:hover {
      text-decoration: underline;
    }
  }
  .next_btn {
    color: #fff;
    background: linear-gradient( 90deg, #F27FC0 0%, #E40080 100%);
    border: none;
  }
}
  .stand-prepare {
    font-size: 20px;
    font-weight: 500;
    color: #2c2c2e;
    line-height: 28px;
    margin: 50px 0 20px;
  }
  .template-main {
   
    .template-left {
      display: flex;
      flex-wrap: wrap;
     
    }
    .template-right {
      flex: 1;
      // padding: 0 60px;
    }
  }
  // 展商信息
  .ex-infor {
    margin-top: 0;
    padding-bottom: 0;
    margin-bottom: 0;
    border-bottom: 0 none;
    .ex-wrap {
      color: #2c2c2e;
      margin-right: 20px;
      .ex-title {
        font-size: 18px;
        font-weight: 500;
        line-height: 28px;
        width: 100%;
      }
      .ex-content {
        width: 360px;
        height: auto;
        padding: 23px;
        margin-top: 1px;
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 30px;
        box-sizing: border-box;
        background: linear-gradient(90deg, #e4ecfd 0%, #f9fbff 100%);
        border-radius: 18px;
        > div {
          margin-bottom: 13px;
        }
        .ex-tinfor {
          display: flex;
          flex-wrap: wrap;
          align-content: center;
          .ex-left {
            width: 56px;
            height: 20px;
            display: inline-block;
            text-align: justify;
            &:after {
              content: "";
              display: inline-block;
              width: 100%;
            }
          }
          .ex-right {
            flex: 1;
          }
        }
        .mb0 {
          margin-bottom: 0;
        }
      }
    }
  }
  .borderno {
    border-bottom: 0 none;
  }
  .template-item {
    color: #fff;
    font-size: 20px;
    position: relative;
    margin-bottom: 30px;
    margin-right: 22px;
    // background: linear-gradient(135deg, #FEB45B 0%, #F2508C 100%, #F24F8D 100%);
    .title {
      flex: 1;
    }
    .sub {
      color: #fff;
      width: 100%;
      font-size: 16px;
      margin-top: 5px;
      font-weight: normal;
    }
    .t-enter {
      color: #fff;
      position: relative;
      z-index: 9;
    }
    > * {
      z-index: 9;
    }
    &::before {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 15px;
      z-index: 2;
      background: linear-gradient(135deg, #feb45b 0%, #f2508c 100%, #f24f8d 100%);
    }
    &::after {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 50%;
      width: 80%;
      height: 20px;
      z-index: 1;
      transform: translateX(-50%);
      background: linear-gradient(135deg, #ffa431 0%, #ef2073 100%);
      border-radius: 8px;
      filter: blur(12px);
    }
    &:hover {
      color: #fff;
    }
    &:hover::before {
      background: linear-gradient(135deg, #ffa431 0%, #ef2073 100%);
    }
  }
  .tem-pink {
    &::before {
      background: linear-gradient(135deg, #8eb2fd 0%, #be60cb 100%);
    }
    &::after {
      background: linear-gradient(135deg, #71a4ff 0%, #b035bd 100%);
    }
    &:hover::before {
      background: linear-gradient(135deg, #71a4ff 0%, #b035bd 100%);
    }
  }
  .tem-blue {
    &::before {
      background: linear-gradient(135deg, #8ac7f3 0%, #358ece 100%);
    }
    &::after {
      background: linear-gradient(
        135deg,
        #72bdf3 0%,
        #55a9e6 23%,
        #1880cc 75%,
        #0070c2 100%
      );
    }
    &:hover::before {
      background: linear-gradient(
        135deg,
        #72bdf3 0%,
        #55a9e6 23%,
        #1880cc 75%,
        #0070c2 100%
      );
    }
  }
  .tem-green {
    &::before {
      background: linear-gradient(135deg, #32d4b4 0%, #32aba2 100%);
    }
    &::after {
      background: linear-gradient(135deg, #00cba2 0%, #00968b 100%);
    }
    &:hover::before {
      background: linear-gradient(135deg, #00cba2 0%, #00968b 100%);
    }
  }
  .rich-text /deep/ img {
    max-width: 100%;
  }
  .rich-text {
    height: 500px;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      width: 0px;
      height: 5px;
    }
    // &::-webkit-scrollbar-track-piece {
    //   background-color: rgba(0, 0, 0, 0.1);
    //   -webkit-border-radius: 6px;
    // }
    // &::-webkit-scrollbar-thumb:vertical {
    //   height: 5px;
    //   background-color: rgba(125, 125, 125, 0.3);
    //   -webkit-border-radius: 6px;
    // }
    // &::-webkit-scrollbar-thumb:horizontal {
    //   width: 5px;
    //   background-color: rgba(125, 125, 125, 0.3);
    //   -webkit-border-radius: 6px;
    // }
  }
  .booth-infor {
    .booth-div {
      font-size: 18px;
      color: #ccc;
      line-height: 25px;
      margin-bottom: 20px;
      .booth-left {
        width: 74px;
        height: 25px;
        color: #2c2c2e;
        margin-bottom: 10px;
      }
      .booth-right {
        .booth-imgwrap {
          width: 100%;
          max-width: 862px;
          margin-bottom: 20px;
          .booth-image {
            width: 100%;
            border-radius: 10px;
          }
          .booth-text {
            color: #999;
            font-size: 14px;
            line-height: 20px;
            text-align: center;
          }
        }
      }
    }
  }
  @media only screen and (max-width: 1280px) {
    .template-main .template-left {
      width: 100% !important;
      padding: 30px 0 70px 20px;
  }
  }
  @media only screen and (max-width: 767px) {
    .title{
      font-size: 16px !important;
    }
    .template-item .sub[data-v-2feb20eb] {
      font-size: 12px !important;
    }
    .content{
      // padding: initial !important;
      margin: initial !important;
    }
    .t-enter {
      font-size: 12px !important;
    }
    .el-button{
      font-size: 15px !important;
    }
  .template-left{
    width: 100% !important;
    padding: 30px 0 70px 0;
  }
  .template-item{
    width: 100% !important;
  }
    .template-right{
      padding: initial !important;
    }
    .template-main {
      margin-top: 10px;
  }
  .rich-text{
    padding: initial !important;
    height: initial !important;
  }
    
   
  }
  </style>